'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _truncatedConeGeometry = require('./truncated-cone-geometry');

var _truncatedConeGeometry2 = _interopRequireDefault(_truncatedConeGeometry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConeGeometry = function (_TruncatedConeGeometr) {
  _inherits(ConeGeometry, _TruncatedConeGeometr);

  function ConeGeometry() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ConeGeometry);

    var _opts$radius = opts.radius,
        radius = _opts$radius === undefined ? 1 : _opts$radius,
        _opts$cap = opts.cap,
        cap = _opts$cap === undefined ? true : _opts$cap;
    return _possibleConstructorReturn(this, (ConeGeometry.__proto__ || Object.getPrototypeOf(ConeGeometry)).call(this, Object.assign({}, opts, {
      topRadius: 0,
      topCap: Boolean(cap),
      bottomCap: Boolean(cap),
      bottomRadius: radius
    })));
  }

  return ConeGeometry;
}(_truncatedConeGeometry2.default);

exports.default = ConeGeometry;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9nZW9tZXRyeS9jb25lLWdlb21ldHJ5LmpzIl0sIm5hbWVzIjpbIkNvbmVHZW9tZXRyeSIsIm9wdHMiLCJyYWRpdXMiLCJjYXAiLCJPYmplY3QiLCJhc3NpZ24iLCJ0b3BSYWRpdXMiLCJ0b3BDYXAiLCJCb29sZWFuIiwiYm90dG9tQ2FwIiwiYm90dG9tUmFkaXVzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7OztJQUVxQkEsWTs7O0FBQ25CLDBCQUF1QjtBQUFBLFFBQVhDLElBQVcsdUVBQUosRUFBSTs7QUFBQTs7QUFBQSx1QkFDWUEsSUFEWixDQUNkQyxNQURjO0FBQUEsUUFDZEEsTUFEYyxnQ0FDTCxDQURLO0FBQUEsb0JBQ1lELElBRFosQ0FDRkUsR0FERTtBQUFBLFFBQ0ZBLEdBREUsNkJBQ0ksSUFESjtBQUFBLHVIQUVmQyxPQUFPQyxNQUFQLENBQWMsRUFBZCxFQUFrQkosSUFBbEIsRUFBd0I7QUFDNUJLLGlCQUFXLENBRGlCO0FBRTVCQyxjQUFRQyxRQUFRTCxHQUFSLENBRm9CO0FBRzVCTSxpQkFBV0QsUUFBUUwsR0FBUixDQUhpQjtBQUk1Qk8sb0JBQWNSO0FBSmMsS0FBeEIsQ0FGZTtBQVF0Qjs7Ozs7a0JBVGtCRixZIiwiZmlsZSI6ImNvbmUtZ2VvbWV0cnkuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgVHJ1bmNhdGVkQ29uZUdlb21ldHJ5IGZyb20gJy4vdHJ1bmNhdGVkLWNvbmUtZ2VvbWV0cnknO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBDb25lR2VvbWV0cnkgZXh0ZW5kcyBUcnVuY2F0ZWRDb25lR2VvbWV0cnkge1xuICBjb25zdHJ1Y3RvcihvcHRzID0ge30pIHtcbiAgICBjb25zdCB7cmFkaXVzID0gMSwgY2FwID0gdHJ1ZX0gPSBvcHRzO1xuICAgIHN1cGVyKE9iamVjdC5hc3NpZ24oe30sIG9wdHMsIHtcbiAgICAgIHRvcFJhZGl1czogMCxcbiAgICAgIHRvcENhcDogQm9vbGVhbihjYXApLFxuICAgICAgYm90dG9tQ2FwOiBCb29sZWFuKGNhcCksXG4gICAgICBib3R0b21SYWRpdXM6IHJhZGl1c1xuICAgIH0pKTtcbiAgfVxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/geometry/cone-geometry.js
// module id = 469
// module chunks = 0